module.exports = __webpack_public_path__ + "img/ski_sub_title6m.ba95522b.jpg";